import { RootState } from 'editor/src/store/index';

const isZoomMode = (state: RootState) => state.editor.zoomMode;

export default isZoomMode;
